import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {NavItem} from '../../styles'
import {ActualItem} from '../navigation-item/styles'

type SignUpButtonNavItemProps = {
  isHamburger?: boolean
}

export const SignUpButtonNavItem = styled(NavItem)<SignUpButtonNavItemProps>`
  ${({isHamburger}): FlattenSimpleInterpolation | string =>
    isHamburger
      ? css`
          margin-top: 8px;
          margin-bottom: 8px;
          margin-left: 16px;
        `
      : ''}
`

export const SignUpButtonActualItem = styled(ActualItem)`
  padding: 0 0 0 8px;
`
